import { Observable,of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import {BpgCommonService} from '../bpg-common/services/bpg-common.service';

@Injectable({
  providedIn:'root'
})

export class BpgAdminServices{
  constructor(private readonly http:HttpClient,
    private readonly bpgCommonService:BpgCommonService) { }

  adminListApi: string = ConstantValues.userManagementApiUrl.adminList;
  URI: string = ConstantValues.userManagementApiUrl.userManagementUrl;
  adminDeleteApi: string = ConstantValues.userManagementApiUrl.deleteAdmin;
  adminSaveApi: string = ConstantValues.userManagementApiUrl.saveAdmin;
  chapterAdminListApi: string = ConstantValues.userManagementApiUrl.chapterAdminList;
  chapterAdminSaveApi: string = ConstantValues.userManagementApiUrl.saveChapterAdmin;
  deleteChapterAdminApi: string = ConstantValues.userManagementApiUrl.deleteChapterAdmin;
  updateEmailApi: string = ConstantValues.userManagementApiUrl.updateEmail;
  naacadminSaveApi: string = ConstantValues.userManagementApiUrl.savenaacAdmin;
  naacadminListApi: string = ConstantValues.userManagementApiUrl.naacadminList;
  naacadminDeleteApi: string = ConstantValues.userManagementApiUrl.deletenaacAdmin;
  updateMembershipEmailApi: string = ConstantValues.userManagementApiUrl.saveMembershipUserEmail;
  /** For service call to GET all admins
   * @class BpgAdminServices
   * @method getAllAdmins
   * @param landingData
   * @returns Observable
   */

  public getAllAdmins(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.adminListApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

    /** For service call to GET all Naac admins
   * @class BpgAdminServices
   * @method getAllNaacAdmins
   * @param landingData
   * @returns Observable
   */

  public getAllNaacAdmins(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.naacadminListApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }
  /** For service call to Delete ADMIN
  * @class BpgAdminServices
  * @method deleteAdmin
  * @param landingData
  * @returns Observable
  */

  public deleteAdmin(id): Observable<any> {

    return this.http.delete(this.URI + this.adminDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

    /** For service call to Delete NAAC ADMIN
  * @class BpgAdminServices
  * @method deletenaacAdmin
  * @param landingData
  * @returns Observable
  */

 public deleteNaacAdmin(id): Observable<any> {

  return this.http.delete(this.URI + this.naacadminDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}

  /** For service call to SAVE ADMIN
* @class BpgAdminServices
* @method saveAdmin
* @param landingData
* @returns Observable
*/

  public saveAdmin(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.adminSaveApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

    /** For service call to SAVE NNAC ADMIN
* @class BpgAdminServices
* @method saveNaacAdmin
* @param landingData
* @returns Observable
*/

public saveNaacAdmin(landingData: any): Observable<any> {

  return this.http.post(this.URI + this.naacadminSaveApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}
/** For service call to Update EMAIL
  * @class BpgAdminServices
  * @method updateEmail
  * @param landingData
  * @returns Observable
  */

 public updateEmail(landingData: any): Observable<any> {
  return this.http.post(this.URI + this.updateEmailApi ,landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}
/** For service call to Update EMAIL from membership screen
  * @class BpgAdminServices
  * @method updateEmail
  * @param landingData
  * @returns Observable
  */
public updateMembershipEmail(landingData: any): Observable<any> {
  return this.http.post(this.URI + this.updateMembershipEmailApi ,landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}
  /** For service call to GET all chapter admins
   * @class BpgAdminServices
   * @method getAllChapterAdmins
   * @param landingData
   * @returns Observable
   */

  public getAllChapterAdmins(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.chapterAdminListApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))

  }

  /** For service call to SAVE ADMIN
* @class BpgAdminServices
* @method saveAdmin
* @param landingData
* @returns Observable
*/

public saveChapterAdmin(landingData: any): Observable<any> {

  return this.http.post(this.URI + this.chapterAdminSaveApi, landingData,this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}

 /** For service call to Delete Chapter ADMIN
  * @class BpgAdminServices
  * @method deleteChapterAdmin
  * @param landingData
  * @returns Observable
  */

 public deleteChapterAdmin(landingData:any): Observable<any> {

  return this.http.post(this.URI + this.deleteChapterAdminApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    return data;

  }))
    .pipe(catchError((error: any) => {
      throw of(error);
    }))
}

}
